export { default as BROWSER } from 'esm-env/browser';
export { default as DEV } from 'esm-env/development';
export { default as NODE } from 'esm-env/node';
